/* eslint-disable no-undef, arrow-body-style, no-param-reassign, no-console */

import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

import metrics from '../modules/metrics/store';
import campaign from '../modules/campaign/store';
import profile from '../modules/profile/store';
import integrations from '../modules/integrations/store';
import entity from '../modules/entity/store';
import poll from '../modules/poll/store';
import recipient from '../modules/recipient/store';
import issue from '../modules/issue/store';
import tickets from '../modules/tickets/store';
import group from '../modules/group/store';
import log from '../modules/log/store';

const qs = require('qs');

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		metrics,
		campaign,
		profile,
		integrations,
		entity,
		poll,
		recipient,
		issue,
		tickets,
		group,
		log,
	},
	state: {
		authorization: false,
		userId: String,
		apiKey: String,
		status: String,
		error: {},
		notifications: {},
		organization: {},
		user: {
			city: {},
			contact: {},
			facebook_active_page: {},
			greeting: {},
			office: {},
			organization: {},
			party: {},
			state: {},
		},
		menu: [],
		routes: [],
		modules: [],

		// contacts: {},
		register: {
			states: {},
			citys: {},
			office: {},
			partys: {},
			movements: {},
		},

		// errorstatus

		statusError: Number,
	},

	actions: {
		getParty: ({ commit }) => {
			axios.get(`${config.api}/party`).then((response) => {
				response.data.party.name = response.data.party.map((p) => {
					const prepositions = ['do', 'dos', 'da', 'das', 'e'];
					p.name = p.name
						.toLowerCase()
						.split(' ')
						.map((word) => {
							if (prepositions.indexOf(word) === -1) {
								return word[0].toUpperCase() + word.slice(1);
							}
							return word;
						})
						.join(' ');
				});
				response.data.party = response.data.party.sort((a, b) => {
					const nameA = a.name.toLowerCase(); // ignore upper and lowercase
					const nameB = b.name.toLowerCase(); // ignore upper and lowercase
					return nameA.localeCompare(nameB);
				});
				commit('getParty', response.data.party);
			});
		},
		getMovement: ({ commit }) => {
			axios.get(`${config.api}/movement`).then((response) => {
				commit('getMovement', response.data.movements);
			});
		},
		getOffice: ({ commit }, payload) => {
			axios
				.get(`${config.api}/office?gender=${payload}`)
				.then((response) => {
					commit('setOffice', response.data);
				});
		},
		stateCountry: ({ commit }) => {
			axios.get(`${config.api}/state`).then((response) => {
				commit('stateCountry', response.data);
			});
		},
		citiesOfState: ({ commit }, payload) => {
			axios
				.get(`${config.api}/city?state_id=${payload}`)
				.then((response) => {
					response.data.city = response.data.city.sort((a, b) => {
						const nameA = a.name.toLowerCase(); // ignore upper and lowercase
						const nameB = b.name.toLowerCase(); // ignore upper and lowercase
						return nameA.localeCompare(nameB);
					});
					commit('citiesState', response.data);
				});
		},
		registerUser: ({ commit }, payload) => {
			const str = qs.stringify(payload);
			return new Promise((resolve, reject) => {
				axios.post(`${config.api}/register/politician`, str).then(
					(response) => {
						resolve(response);
						commit('setSuccess');
						sessionStorage.removeItem('pages');
					},
					(error) => {
						reject(error);
						commit('setError', error.response.data);
						commit('statusCheck', error.response.status);
					},
				);
			});
		},
		editOfficer: ({ commit }, payload) => {
			const userStr = qs.stringify(payload.str);
			return new Promise((resolve, reject) => {
				axios
					.put(
						`${config.api}/politician/${
							payload.session.userId
						}?api_key=${payload.session.apiKey}`,
						userStr,
					)
					.then(
						(response) => {
							resolve(response);
							commit('setSuccess');
						},
						(error) => {
							reject(error);
							commit('setError', error.response.data);
							commit('statusCheck', error.response.status);
						},
					);
			});
		},
		editUser: ({ commit, rootState }, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					method: 'PUT',
					headers: { 'Content-Type': 'multipart/form-data' },
					url: `${config.api}/politician/${rootState.userId}?api_key=${rootState.apiKey}`,
					data: payload,
				}).then((response) => {
					resolve(response);
					commit('setSuccess');
				}).catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
			});
		},
		authenticLogin: ({ commit }, payload) => new Promise((resolve, reject) => {
			const userStr = qs.stringify(payload);
			axios
				.post(`${config.api}/login`, userStr)
				.then((response) => {
					resolve(response);
					commit('setAuthentication', response.data);
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data);
				});
		}),
		loadUser: ({ commit, rootState }, payload) => new Promise((resolve, reject) => {
			axios.get(`${config.api}/politician/${payload.userId}?api_key=${payload.apiKey}`)
				.then((response) => {
					resolve(response);
					commit('setUser', response.data);
				}).catch((error) => {
					reject(error);
					commit('errorLogin', { error: error.response, root: rootState });
				});
		}),
		signOut: ({ commit }, payload) => {
			commit('signOut', payload);
		},
		registerDialog: ({ commit, rootState }, payload) => {
			payload.dialogForm = payload.dialogForm.replace(/\+/g, '%2B');
			payload.dialogForm = payload.dialogForm.replace(/;/g, '%3B');
			return new Promise((resolve, reject) => {
				console.log(payload.dialogForm);
				axios.post(`${config.api}/politician/${rootState.userId}/answers?api_key=${rootState.apiKey}&`, `${payload.dialogForm}`)
					.then((response) => {
						resolve(response);
						commit('setSuccess');
					})
					.catch((error) => {
						reject(error);
						commit('setError', error.response.data, { root: true });
						commit('statusCheck', error.response.status);
					});
			});
		},
		editDialog: ({ commit, rootState }, payload) =>
			new Promise((resolve, reject) => {
				axios({
					method: 'PUT',
					headers: { 'Content-Type': 'multipart/form-data' },
					url: `${config.api}/politician/${rootState.userId}/answers/${payload.get('id')}?api_key=${rootState.apiKey}`,
					data: payload,
				}).then((response) => {
					resolve(response);
					commit('setSuccess');
				}).catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
			}),
		emailPasswordReset: ({ commit }, payload) => {
			return new Promise((resolve) => {
				axios
					.post(`${config.api}/login/forgot_password?email=${payload}`)
					.then((response) => {
						resolve(response);
						if (response.status) {
							commit('setSuccess');
						}
					})
					.catch((error) => {
						commit('setError', error.response.data);
					});
			});
		},
		resetPassword: ({ commit }, payload) => {
			axios
				.post(`${config.api}/login/forgot_password/reset/${
					payload.token[0]
				}?new_password=${payload.new_password}`)
				.then((response) => {
					if (response.status === 200) {
						commit('setSuccess');
					}
				})
				.catch((error) => {
					commit('setError', error.response.data);
				});
		},
		getNotifications: ({ commit }, payload) => new Promise((resolve, reject) => {
			axios.get(`${config.api}/politician/${payload.userId}/notification-bar?api_key=${payload.apiKey}`)
				.then((response) => {
					resolve(response);
					commit('setNotifications', response.data, { root: true });
				}).catch((error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				});
		}),
	},

	mutations: {
		setMenu: (state, payload) => {
			state.menu = payload;
		},
		setModules: (state, payload) => {
			state.modules = payload;
		},
		setRoutes: (state, payload) => {
			state.routes = payload;
		},
		setUser: (state, payload) => {
			state.authorization = true;
			state.user = payload;
			state.apiKey = sessionStorage.getItem('apiKey');
			state.userId = sessionStorage.getItem('userId');
		},
		getMovement: (state, payload) => {
			state.register.movements = payload;
		},
		getParty: (state, payload) => {
			state.register.partys = payload;
		},
		setOffice: (state, payload) => {
			state.register.office = payload;
		},
		stateCountry: (state, payload) => {
			state.register.states = payload;
		},
		citiesState: (state, payload) => {
			state.register.citys = payload;
		},
		setAuthentication: (state, payload) => {
			sessionStorage.removeItem('statusCode');
			state.user = payload;
			state.organization = payload;
			state.authorization = true;
			sessionStorage.setItem('apiKey', payload.api_key);
			sessionStorage.setItem('userId', payload.user_id);
			sessionStorage.setItem('organizations', JSON.stringify(payload.organizations));
		},
		signOut: (state, _) => {
			const apiKey = sessionStorage.getItem('apiKey');
			if (apiKey) {
				state.user = '';
				state.authorization = false;
				state.apiKey = '';
				sessionStorage.removeItem('apiKey');
				sessionStorage.removeItem('userId');
				sessionStorage.removeItem('statusCode');
			}
		},
		setError: (state, payload) => {
			if (payload.form_error) {
				state.error = payload.form_error;
			} else {
				state.error = payload;
			}
			state.status = false;
		},
		statusCheck: (state, payload) => {
			if (payload === 403) {
				sessionStorage.setItem('statusCode', payload);
			}
		},
		setSuccess: (state) => {
			state.status = true;
			state.error = false;
		},
		setNotifications: (state, payload) => {
			state.notifications = payload;
		},
	},
});

export default store;



// WEBPACK FOOTER //
// ./_source/javascripts/store/index.js